import React from 'react';
import { IIcon, useIconProps } from '../useIconProps';
import SvgIconAccounts from './accounts.svgrIcon.svg';
import SvgIconBonuses from './bonuses.svgrIcon.svg';
import SvgIconFunding from './funding.svgrIcon.svg';
import SvgIconHelpCenter from './helpCenter.svgrIcon.svg';
import SvgIconLoyaltyProgram from './loyaltyProgram.svgrIcon.svg';
import SvgIconNotifications from './notifications.svgrIcon.svg';
import SvgIconPartnership from './partnership.svgrIcon.svg';
import SvgIconProfile from './profile.svgrIcon.svg';
import SvgIconSales from './sales.svgrIcon.svg';
import SvgIconSettings from './settings.svgrIcon.svg';
import SvgIconSocialTrading from './socialTrading.svgrIcon.svg';
import SvgIconTradingContest from './tradingContest.svgrIcon.svg';
import SvgIconTradingPlatforms from './tradingPlatforms.svgrIcon.svg';
import SvgIconTradingTools from './tradingTools.svgrIcon.svg';

interface IMenuIcon extends IIcon {
  icon:
    | 'profile'
    | 'accounts'
    | 'funding'
    | 'tradingPlatforms'
    | 'tradingTools'
    | 'socialTrading'
    | 'notifications'
    | 'helpCenter'
    | 'partnership'
    | 'sales'
    | 'bonuses'
    | 'settings'
    | 'tradingContest'
    | 'loyaltyProgram';
}

export const MenuIcon = React.forwardRef(({ icon, ...props }: IMenuIcon, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    ...props,
  });

  const renderIcon = () => {
    switch (icon) {
      case 'profile':
        return <SvgIconProfile {...iconProps} />;
      case 'accounts':
        return <SvgIconAccounts {...iconProps} />;
      case 'funding':
        return <SvgIconFunding {...iconProps} />;
      case 'tradingPlatforms':
        return <SvgIconTradingPlatforms {...iconProps} />;
      case 'tradingTools':
        return <SvgIconTradingTools {...iconProps} />;
      case 'socialTrading':
        return <SvgIconSocialTrading {...iconProps} />;
      case 'notifications':
        return <SvgIconNotifications {...iconProps} />;
      case 'tradingContest':
        return <SvgIconTradingContest {...iconProps} style={{ transform: 'scale(1.3)' }} />;
      case 'loyaltyProgram':
        return <SvgIconLoyaltyProgram {...iconProps} style={{ transform: 'scale(1.3)' }} />;
      case 'helpCenter':
        return <SvgIconHelpCenter {...iconProps} />;
      case 'partnership':
        return <SvgIconPartnership {...iconProps} />;
      case 'sales':
        return <SvgIconSales {...iconProps} />;
      case 'bonuses':
        return <SvgIconBonuses {...iconProps} />;
      case 'settings':
        return <SvgIconSettings {...iconProps} />;
    }
  };

  return renderIcon();
});
